import { UIHeading2 } from '@cian/ui-kit';

import { type ReactNode } from 'react';

import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors';

import { PriceLayout } from '../components/PriceLayout';

import { VASIconsContainer } from './VASIconsContainer';

export function PriceContainer(): ReactNode {
  const {
    terms: { price },
  } = useCardOfferDataContext();

  return (
    <PriceLayout>
      <UIHeading2>
        <span data-testid="card.price">{price}</span>
      </UIHeading2>
      <PriceLayout.VAS>
        <VASIconsContainer />
      </PriceLayout.VAS>
    </PriceLayout>
  );
}
